import React, { useEffect, useState } from 'react';
import { Form, Input, Button, notification, Row, Col } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { warningsApi } from '../apiCalls/warningsApi';
import PageTitle from '../components/PageTitle';

const WarningFormEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchWarning = async () => {
      setLoading(true);
      const warning: any = await warningsApi.getWarningById(id!);
      if (warning) {
        form.setFieldsValue({
          name: warning.name,
        });
      } else {
        notification.error({
          message: 'Error',
          description: 'Warning not found.',
          duration: 3,
        });
      }
      setLoading(false);
    };

    fetchWarning();
  }, [id, form]);

  const onFinish = async (values: any) => {
    const warningData = {
      ...values,
    };

    const result = await warningsApi.updateWarning(id!, warningData);
    if (result) {
      notification.success({
        message: 'Warning Updated',
        description: 'The warning has been successfully updated.',
        duration: 3,
      });
      navigate('/warnings');
    } else {
      notification.error({
        message: 'Error updating',
        description: 'There was an error updating the asset.',
        duration: 3,
      });
    }
  };

  return (
      <div style={{ padding: 24 }}>
        <PageTitle title="Edit Warning" />
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Name" name="name">
                <Input placeholder="Enter the name" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Warning
            </Button>
          </Form.Item>
        </Form>
      </div>
  );
};

export default WarningFormEdit;
